import {createSelectorHook} from "react-redux";
import {ResumeReduxContext} from "@/components/resume/redux/context";

export default createSelectorHook(ResumeReduxContext)
